<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/chongzhou/1/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="zcjj">
          <img
            class="top"
            style="height: 2.12rem"
            src="../../assets/imgs/chongzhou/1/title.png"
            alt=""
          />
          <div class="content">
            <div class="des">
              以“聚资源、兴服务、惠人才”为目标，从增加应用场景、提级服务质量、拓宽覆盖范围等方面，为各类在崇高层次人才提供更为便捷、更加优质、更具特色的人才服务事项。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/1/title-1.png"
            alt=""
          />
          <div class="content">
            经人社部门认定的符合《崇州市重点产业企业高层次人才目录》Ⅰ、Ⅱ、Ⅲ、Ⅳ、Ⅴ类人才。
          </div>
        </div>
        <div class="sscl">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/1/title-2.png"
            alt=""
          />
          <div class="content">
            <div style="font-size: 0.26rem; color: #333; font-weight: 600">
              推出“蜀城英才绿卡·五安工程”服务体系建设，在“创业安心”“家庭安顿”“身体安康”“出行安享”“生活安乐”五大类别上，为高层次人才提供33项高质量优待服务。
            </div>
            <div class="des">
              <span>1.创新创业服务：</span
              >政务服务全流程导办帮办代办、法律咨询专属服务、项目申报、一站式企业服务、全域银行VIP服务等；
            </div>
            <div class="des">
              <span>2.家庭安顿服务：</span
              >人才租购房保障、人才及家属落户优先、子女就学等；
            </div>
            <div class="des">
              <span>3.医疗健康服务：</span
              >重点三甲医院绿色就医服务、医保业务帮办代办服务等；
            </div>
            <div class="des">
              <span>4.出行保障服务：</span
              >机场贵宾服务、公共区域免费停车、公交免费乘坐等；
            </div>
            <div class="des">
              <span>5.生活休闲服务：</span
              >时蔬粮油配送、文化展演、运动健身、餐饮酒店（景点民宿）优惠等。
            </div>
          </div>
        </div>
        <div class="sbcl">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/1/title-3.png"
            alt=""
          />
          <div class="content">
            <div class="des">
              <div class="item">
                <div class="line"></div>
                <div class="dot">1</div>
                “崇州人才智慧服务平台”在线申请；
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">2</div>
                园区或行业主管部门初审；
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">3</div>
                认定条件部门复审；
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">4</div>
                市人社局终审；
              </div>
              <div class="item">
                <div class="dot">5</div>
                人才办复核，进行公示。
              </div>
            </div>
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/1/title-4.png"
            alt=""
          />
          <div class="content">
            <div class="number" style="padding-left: 2.5rem">
              <span class="label">政策咨询电话：</span>
              <div>
                <div><a href="tel:028-82215255">028-82215255</a></div>
                <div><a href="tel:028-82228953">028-82228953</a></div>
                <!-- <div
                  :key="index"
                  v-for="(
                    item, index
                  ) in contact.contacts[0].contactInformation.split(',')"
                >
                  <a href="tel:028-83221725">{{ item }}</a>
                </div> -->
              </div>
            </div>
            <div
              class="number"
              style="padding-left: 2.5rem; margin-top: 0.2rem"
            ></div>
            <!-- <div>咨询单位：{{ contact.contacts[0].responsibleUnit }}</div> -->
            <div>咨询单位：崇州市委人才办</div>
          </div>
        </div>
        <div class="codes">
          <img class="code" src="../../assets/imgs/chongzhou/1/code.png" />
          <!-- <img class="text" src="../../assets/imgs/chongzhou/1/text.png" /> -->
        </div>
      </div>
    </section>
    <!-- <NewCall :obj="contact"></NewCall> -->
  </div>
</template>

<script>
import NewCall from "../../components/NewCall.vue";
export default {
  data() {
    return {
      contact: {},
    };
  },

  components: {
    NewCall,
  },

  async mounted() {
    const { data } = await this.$policy(92);
    this.contact = data;
  },

  methods: {
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
  }

  .technological-process {
    transform: translateY(-1.8rem);

    .sscl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.4rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.22rem;
          position: relative;
          span {
            font-weight: 600;
          }
        }
      }
    }

    .zcjj {
      // background-color:#fff;
      .top {
        width: 6.68rem;
        height: 2.12rem;
      }

      .content {
        width: 6.68rem;
        background: #ffffff;
        margin: -0.45rem auto 0;
        padding: 0.1rem 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        line-height: 0.44rem;

        .title {
          font-size: 0.34rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          font-size: 0.26rem;
          color: #4e4e4e;
          text-align: left;
          margin-top: 0.16rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.8rem;
          position: relative;
          text-align: center;

          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 2.98rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        font-size: 0.26rem;

        .des {
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          padding-top: 0.1rem;
          margin-top: 0.2rem;
          position: relative;

          .item {
            margin-top: 0.35rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            line-height: 0.44rem;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 135%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.1rem;
              top: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code {
        width: 6.19rem;
      }

      .text {
        width: 4rem;
      }
    }
  }
}
</style>
